import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainConsoleComponent from "../components/console/MainConsoleComponent";
import UsersPage from "../components/console/users-page/UsersPage";
import RolesPage from "../components/console/roles-page/RolesPage";
import ProductFeaturesPage from "../components/console/product-features-page/ProductFeaturesPage";
import NewsPage from "../components/console/news-page/NewsPage";
import SystemEventsPage from "../components/console/system-events-page/SystemEventsPage";
import ManagementPage from "../components/console/management-page/ManagementPage";
import EventsPage from "../components/console/events-page/EventsPage";
import PartnersPage from "../components/console/partners-page/PartnersPage";
import DevelopmentHistoryPage from "../components/console/development-history-page/DevelopmentHistoryPage";
import ContactsPage from "../components/console/contacts-page/ContactsPage";
import CoursesPage from "../components/console/courses-page/CoursesPage";

const ConsoleRoutes: FC = () => {
    return (
        <Routes>
            <Route path="/" element={<MainConsoleComponent />}>
                <Route index element={<Navigate to="users" replace />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="roles" element={<RolesPage />} />
                <Route path="productFeatures" element={<ProductFeaturesPage />} />
                <Route path="news" element={<NewsPage />} />
                <Route path="management" element={<ManagementPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="partners" element={<PartnersPage />} />
                <Route path="development-history" element={<DevelopmentHistoryPage />} />
                <Route path="contacts" element={<ContactsPage />} />
                <Route path="courses" element={<CoursesPage />} />
                <Route path="systemEvents" element={<SystemEventsPage />} />
            </Route>
        </Routes>
    );
};

export default ConsoleRoutes;
